import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/styles';
import roles from '../../helpers/roles';
import { ActiveCallsTab, CompletedCallsTab, NeedsAttentionTab, FlaggedCallsTab, QueueTab, CallMetricsTab } from './CallManagerTabContent';
import cn from 'classnames';
import AutomatedCallConfigurationTab from './AutomatedCallConfigurationTab';

// TABS
import { TabBar } from '../TabBar';

const { ADMIN } = roles;

const styles = theme => ({
  root: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  tabContent: {
    flex: 1,
    width: '100%',
  },
});

export const CALL_MANAGER_TAB_KEY = 'CALL_MANAGER_TAB';
export const tabKeys = {
  queue: 'queue',
  active: 'active',
  completed: 'completed',
  flagged: 'flagged',
  configuration: 'configuration',
  metrics: 'metrics',
};

const CallManagerContent = withStyles(styles)(props => {
  const {
    classes,
    columns,
    data,
    actionButtons,
    title,
    loading,
    pageSize,
    totalCount,
    page,
    setPage,
    setPageSize,
    fetchCallList,
  } = props;
  const [activeTab, setActiveTab] = useState(0);

  const updateActiveTab = key => {
    localStorage.setItem(CALL_MANAGER_TAB_KEY, key);
    const activeTabIndex = tabs.findIndex(tab => tab.key === key);
    setActiveTab(activeTabIndex);
  };

  const tabs = [
    {
      label: 'Call Queue',
      key: tabKeys.queue,
      permissions: [ADMIN],
      component: (
        <div className={cn(classes.gridContainer, 'card', 'border-left-green')}>
          <QueueTab
            columns={columns}
            data={data}
            actionButtons={actionButtons}
            title={title}
            loading={loading}
            pageSize={pageSize}
            totalCount={totalCount}
            page={page}
            setPage={setPage}
            setPageSize={setPageSize}
            fetchCallList={fetchCallList}
          />
        </div>
      ),
    },
    // {
    //   label: 'Active Calls',
    //   key: tabKeys.active,
    //   permissions: [ADMIN],
    //   component: (
    //     <div className={cn(classes.gridContainer, 'card', 'border-left-green')}>
    //       <ActiveCallsTab />
    //     </div>
    //   ),
    // },
    {
      label: 'Call History',
      key: tabKeys.completed,
      permissions: [ADMIN],
      component: (
        <div className={cn(classes.gridContainer, 'card', 'border-left-green')}>
          <CompletedCallsTab />
        </div>
      ),
    },
    // {
    //   label: 'Flagged Calls',
    //   key: tabKeys.flagged,
    //   permissions: [ADMIN],
    //   component: (
    //     <div className={cn(classes.gridContainer, 'card', 'border-left-green')}>
    //       <FlaggedCallsTab />
    //     </div>
    //   ),
    // },
    {
      label: 'Needs Attention',
      key: tabKeys.needsAttention,
      permissions: [ADMIN],
      component: (
        <div className={cn(classes.gridContainer, 'card', 'border-left-green')}>
          <NeedsAttentionTab />
        </div>
      ),
    },
    {
      label: 'Call Metrics',
      key: tabKeys.metrics,
      permissions: [ADMIN],
      component: (
        <div className={cn(classes.gridContainer, 'card', 'border-left-green')}>
          <CallMetricsTab />
        </div>
      ),
    },
    // {
    //   label: 'Call Configuration',
    //   key: tabKeys.configuration,
    //   permissions: [ADMIN],
    //   component: (
    //     <div className={cn(classes.gridContainer, 'card', 'border-left-green')}>
    //       <AutomatedCallConfigurationTab />
    //     </div>
    //   ),
    // },
  ];

  return (
    <div className={classes.root}>
      <TabBar tabs={tabs} changeTab={updateActiveTab} activeTab={activeTab} />
      <div className={classes.tabContent}>{tabs[activeTab]?.component}</div>
    </div>
  );
});

export const CallManagerTabs = props => <CallManagerContent {...props} />;
